module.exports = __webpack_public_path__ + "fonts/FiraGO-Medium.fdb191bd.ttf";